import React, { useEffect } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Layout from "../components/Layout";
import {
  Signin,
  RedirectCallback,
  LogoutCallback,
} from "../Authentication/Callbacks";
import UnautherizeContent from "../components/UnautherizeContent";
import PrivateRoute from "../Shared/PrivateRoute";
import PageNotFound from "../components/PageNotFound";
import StaticDashboard from "../components/StaticDashboard";
import UserExist from "../components/UserExists";
import { ContactSupportOutlined } from "@material-ui/icons";

function Routes() {
 /*  useEffect(() => {
    setInterval(() => {
      let Client = process.env.REACT_APP_IDENTITY_CONFIG_CLIENT_ID;
    //  let Result = Client.replace(/"/g,'');client_id: 
     // console.log("client",Client,Result)
      let apiUrl = process.env.REACT_APP_REFRESH_TOKEN_URL;
      axios({
        method: "POST",
        url: apiUrl,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: {
          grant_type: "refresh_token",
          client_id: Client,
          refresh_token: JSON.parse(localStorage.getItem("currentUser")).accessToken,
        },
      })
        .then((response) => {
          if (response?.status === 200) {
            const retrievedString = localStorage.getItem("currentUser");
            const parsedObject = JSON.parse(retrievedString);
            parsedObject.accessToken = response?.data?.access_token;
            parsedObject.refreshToken = response?.data?.refresh_token;
            const updateUser = JSON.stringify(parsedObject);
            localStorage.setItem("currentUser", updateUser);
          } else {
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
          }
        });
    },3540000 );
  });  */

  //3540000
  //3600
  return (
    <Router>
      <div>
        <Switch>
          <Route exact={true} path="/" component={StaticDashboard} />
          <Route exact={true} path="/login" component={Signin} />
          <Route exact={true} path="/signin" component={RedirectCallback} />
          <Route exact={true} path="/logout" component={LogoutCallback} />
          <PrivateRoute path="/Home" component={Layout} />
          <Route path="/pagenotfound" component={UnautherizeContent} />
          <Route path="/usernotfound" component={UserExist} />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </div>
    </Router>
  );
}

export default Routes;
